/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Redirect, RedirectProps } from "react-router-dom";
import { ERROR_TEXT } from "~/constants";
import { ACTION, useAccess } from "~/services/auth";
import { showError } from "~/services/toast";
import { ROUTES } from "./routes";

type CommonProps = {
  children: React.ReactElement;
  redirectTo?: string;
};

type Props = CommonProps & {
  action: ACTION;
};

export function RequireAccess({
  action,
  children,
  redirectTo = ROUTES.index,
}: Props) {
  const { hasAccess } = useAccess(action);

  return (
    <AccessHandler hasAccess={hasAccess} redirectTo={redirectTo}>
      {children}
    </AccessHandler>
  );
}

export function AccessHandler({
  hasAccess,
  children,
  redirectTo = ROUTES.accessDenied,
}: CommonProps & { hasAccess: boolean }) {
  if (hasAccess) {
    return children;
  }

  return (
    <RedirectWithMessage message={ERROR_TEXT.accessDenied} to={redirectTo} />
  );
}

function RedirectWithMessage({
  message,
  ...redirectProps
}: RedirectProps & { message: string }) {
  React.useEffect(() => {
    {
      showError(message);
    }
  }, [message]);

  return <Redirect {...redirectProps} />;
}
